import "./genericOfferCard.scss";
// vendors
import React from 'react';
import PropTypes from "prop-types";
import classnames from 'classnames';
import { i18n } from 'core/i18n';
const { FormattedText } = i18n;

const GenericOfferCard = ({
    isFullWidth = false,
    color = "#e1e1f3",
    title,
    headerSecondaryElement,
    tag,
    bodyContent,
    footerContent,
    subtitle
}) => {

    const offerCardClasses = classnames('generic-offer-card', {
        'generic-offer-card--full': isFullWidth,
        'generic-offer-card--cc': __CONTACT_CENTER__,
    });
    const tagClasses = classnames('generic-offer-card__tag', {
        'generic-offer-card__tag--alternative': tag?.tag === 1,
    })

    return (
        <article className={offerCardClasses} style={{ borderColor: color }}>
            <header className="generic-offer-card__header">
                <div className="generic-offer-card__header-text-section">
                    <h2 className="generic-offer-card__header-title">
                        <FormattedText value={title} />
                    </h2>
                    {subtitle && (
                        <h3 className="generic-offer-card__header-subtitle">
                            <FormattedText value={subtitle} />
                        </h3>
                    )}
                    {headerSecondaryElement && (
                        <h4 className="generic-offer-card__header-secondary-element">
                            {headerSecondaryElement}
                        </h4>
                    )}
                </div>
                {
                    tag && (
                        <div className={tagClasses}>
                            <FormattedText value={tag.text} />
                        </div>
                    )
                }
            </header>
            {bodyContent && <section className="generic-offer-card__body">{bodyContent}</section>}
            {footerContent && (
                <footer className="generic-offer-card__footer">
                    {footerContent}
                </footer>
            )}
        </article>
    );
};

GenericOfferCard.propTypes = {
    isFullWidth: PropTypes.bool,
    color: PropTypes.string,
    title: PropTypes.string.isRequired,
    headerSecondaryElement: PropTypes.node,
    tag: PropTypes.shape({
        tag: PropTypes.number,
        text: PropTypes.string
    }),
    bodyContent: PropTypes.node,
    footerContent: PropTypes.node,
    subtitle: PropTypes.string
};



export default GenericOfferCard;